// Core imports - always needed
import setupBootstrap from "./features/bootstrap-customization";
import "./features/font/brands";
import "./features/font/solid";
import "./features/font/fontawesome";
import setupSearch from "./features/search";
import setupNavigation from "./features/navigation";
import setupLogin from "./features/login/login.js";
import setupLoginRegister from "./features/login/login-register.js";
import alertHelper from "./features/alert/alert.js"
import savedBoats from "./features/saved-boats";
import setupSeachMenu from "./features/search-menu-home";
import setupModalWindow from "./features/modal-window";
import setupPhoneFormatting from "./features/phone-format";

// Lazy loading library
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

window.asyncReady(async () => {
    // Initialize core features immediately
    setupLogin();
    setupBootstrap();
    setupSearch();
    setupNavigation();
    setupLoginRegister();
    
    savedBoats();
    setupSeachMenu();
    setupModalWindow();
    setupPhoneFormatting();
    
    // Lazy load boats search module only if boats search form exists
    // Load it early to ensure Choices.js is available when DOM is ready
    const boatsSearchForm = document.getElementById('boatsSearch');
    if (boatsSearchForm) {
        try {
            const { default: initializeBoatsSearch } = await import('./features/boats-search.js');
            initializeBoatsSearch();
        } catch (error) {
            console.error('Failed to load boats-search module:', error);
        }
    }

    // Route-specific dynamic imports for private sellers
    if (window.location.href.includes('/private-seller/')) {
        const [
            { default: setupUserProfile },
            { default: setupEditUserProfile },
            { default: setupSellBoat },
            { default: setupRemoveBoat }
        ] = await Promise.all([
            import('./features/user-profile/user-main.js'),
            import('./features/private-seller/edit-user-profile/edit-user-profile.js'),
            import('./features/private-seller/sell-boat/sell-boat.js'),
            import('./features/user-profile/remove-boat')
        ]);

        setupUserProfile();
        setupEditUserProfile();
        setupSellBoat();
        setupRemoveBoat();
    }

    // Route-specific dynamic imports for dealers
    if (window.location.href.includes('/dealer/')) {
        const [
            { default: setupUserProfile },
            { default: setupEditDealerProfile },
            { default: setupRemoveBoat }
        ] = await Promise.all([
            import('./features/user-profile/user-main.js'),
            import('./features/dealer/edit-dealer-profile/edit-dealer-profile.js'),
            import('./features/user-profile/remove-boat')
        ]);

        setupUserProfile();
        setupEditDealerProfile();
        setupRemoveBoat();
    }

    // Lazy load Swiper only if there are swipers on the page
    if (document.querySelector('.swiper')) {
        const { default: setupSwiper } = await import('./features/swiper.js');
        setupSwiper();
    }

    // Lazy load Fancybox only if there are fancybox elements on the page
    if (document.querySelector('[data-fancybox]')) {
        const { default: setupFancybox } = await import('./features/fancybox');
        setupFancybox();
    }

    // Lazy load Trumbowyg only if there are rich text editors on the page
    if (document.querySelector('.rich-text-editor') || document.querySelector('.trumbowyg-textarea')) {
        const { default: setupRichTextEdit } = await import('./features/trumbowyg');
        setupRichTextEdit();
    }

    // Lazy load spincrement only if there are counter elements on the page
    if (document.querySelector('.spincrement')) {
        const { default: setupSpincrement } = await import('./features/jquery.spincrement.js');
        setupSpincrement();
    }
});
